import { useState } from "react";
import { listProducts, getProduct } from "@/products";

export default function ProductSwitcher() {
  const products = listProducts().filter((p) => p.enabled);
  const [active, setActive] = useState("flights");
  const ActiveSearch = getProduct(active)?.SearchWidget;

  const handleClick = (p) => {
    if (!p.enabled) return;
    setActive(p.key);
  };

  // Show the tab row on mobile even when there is only one product — this
  // is the CheapOair-style "Flights" indicator the user requested. Desktop
  // hides it when there's only one to keep the hero clean.
  const showTabs = products.length > 1 || true;

  return (
    <div data-testid="product-switcher">
      {showTabs && (
        <div
          className={`flex flex-wrap items-center gap-2 mb-5 ${
            products.length === 1 ? "md:hidden" : ""
          }`}
        >
          {products.map((p) => {
            const Icon = p.icon;
            const isActive = active === p.key;
            return (
              <button
                key={p.key}
                type="button"
                onClick={() => handleClick(p)}
                data-testid={`product-tab-${p.key}`}
                className={`flex items-center gap-2 px-4 py-2 text-xs tracking-[0.16em] uppercase font-semibold transition-colors border ${
                  isActive
                    ? "bg-[#C29B62] text-[#0A0A0B] border-[#C29B62]"
                    : "text-[#F7F5F0] border-white/15 hover:border-[#C29B62] hover:text-[#C29B62]"
                }`}
              >
                <Icon size={16} weight={isActive ? "fill" : "duotone"} />
                <span>{p.label}</span>
              </button>
            );
          })}
        </div>
      )}
      {ActiveSearch ? <ActiveSearch /> : null}
    </div>
  );
}
